import { DestroyRef, inject } from '@angular/core';
import { takeWhileAlive } from '../../utils';
import { BehaviorSubject, filter, of, take } from 'rxjs';
import { DevToolsRegistry } from '../../dev-tools';
import { DynamicComponentHelper } from '../../dynamic-components';
import { FeatureService } from '../feature-registry';
import * as i0 from "@angular/core";
import * as i1 from "../feature-registry";
import * as i2 from "../../dev-tools";
export let FeatureRootComponentsService = /*#__PURE__*/(() => {
  class FeatureRootComponentsService {
    constructor(features, debug) {
      this.features = features;
      this.destroyRef = inject(DestroyRef);
      this.rootComponents$ = new BehaviorSubject(null);
      this.features.getLoadedFeatures().pipe(takeWhileAlive(this.destroyRef)).subscribe(activatedFeatures => {
        const cmps = [];
        activatedFeatures.forEach(feature => {
          const definition = feature.getFeatureFunctionalityCached();
          if (definition.rootComponents) {
            cmps.push(...definition.rootComponents);
          }
        });
        this.rootComponents$.next(cmps);
      });
      debug.exposeDebugFunction(['Features', 'Inspect Root Cmps.'], () => {
        return this.rootComponents$.pipe(take(1));
      });
    }
    getRootComponents$() {
      return this.rootComponents$.pipe(filter(cmps => Array.isArray(cmps)), takeWhileAlive(this.destroyRef));
    }
    loadComponentFromManifest(manifest) {
      if (manifest === null) return of(null);
      return DynamicComponentHelper.loadComponent(manifest.component || manifest.load || null);
    }
    static {
      this.ɵfac = function FeatureRootComponentsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeatureRootComponentsService)(i0.ɵɵinject(i1.FeatureService), i0.ɵɵinject(i2.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FeatureRootComponentsService,
        factory: FeatureRootComponentsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FeatureRootComponentsService;
})();